import cn from 'classnames'
import React, { useCallback } from 'react'

import { TooltipCourse } from 'components/Editor/EditorElements/courseKit/DropDownCourse'
import ScreenReaderOnlyText from 'components/Editor/styled/ScreenReaderOnlyText'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { testEnd } from 'services/Store/Project/actions'
import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getBlock, getSection, getSectionState } from 'services/Store/Project/selectors'
import { t } from 'services/Translation'

import { useAccessibleTimer } from '../useTestTimer'
import * as s from './SectionTestTimer.module.scss'

interface ISectionTestTimerProps {
  totalQuestionsDone?: number
}

const SectionTestTimer: React.FC<ISectionTestTimerProps> = ({ totalQuestionsDone }) => {
  const dispatch = useProjectDispatch()
  const time = useProjectContext(getSection)?.test?.time || 0
  const startTime = useProjectContext(getSectionState)?.startTime
  const stop = useProjectContext(getBlock)?.mode === 'start' || !startTime

  const onFinish = useCallback(() => dispatch(testEnd()), [dispatch])

  const { isFire, left, srMessage } = useAccessibleTimer({
    startTime,
    time,
    stop,
    onFinish,
    questionsDone: totalQuestionsDone,
  })

  return (
    <TooltipCourse overlay={t('elements.testFooter.tooltip.timeAll')}>
      <div className={cn(s.root, { [s.fireTime]: isFire })} role='timer'>
        <Icon
          aria-hidden='true'
          className={s.icon}
          name={isFire ? 'statusDeadline20Px' : 'otherClock'}
          size={KitSize.S}
        />
        {left}
        <div aria-atomic='true' aria-live='polite'>
          <ScreenReaderOnlyText>{srMessage}</ScreenReaderOnlyText>
        </div>
      </div>
    </TooltipCourse>
  )
}

export default SectionTestTimer
